import React from 'react';

import { displayPrice } from '@common/utils';

interface ShippingFeeProps {
  shipping_fee: number | null;
  free_shipping_amount: number | null;
  is_shipping_fee_free: boolean;
}
export const ShippingFee: React.FC<React.PropsWithChildren<ShippingFeeProps>> = ({
  shipping_fee,
  free_shipping_amount,
  is_shipping_fee_free,
}) => {
  const shippingFee = shipping_fee && displayPrice(shipping_fee);

  if (shipping_fee === null) {
    return <>정보없음</>;
  }

  if (shipping_fee === 0 || is_shipping_fee_free) {
    return <>무료배송</>;
  }

  if (!!free_shipping_amount && !is_shipping_fee_free) {
    return (
      <>
        {shipping_fee}
        <small>
          &nbsp;·&nbsp;
          {displayPrice(free_shipping_amount)} 이상 무료배송
        </small>
      </>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{shippingFee}</>;
};
